export const getAutoCreditDraftKey = (uuid: string) =>
  `auto-credit_draft_${uuid}`;

export const getVehicleFormKey = (userUuid: string, requestId: string) =>
  `auto-credit_vehicle_${userUuid}_${requestId}`;
